import { Record as record } from 'immutable';
import _ from 'lodash';

import { construct, resolve } from '../helpers/LinkMapper';
import { serialize, serializers } from "../helpers/SearchUrls";

const defaults = {
    routeCode: null,
    ticketTypes: null,
    ticketCategory: null,
    duration: null,
    loadEarlier: true,
};

function getFareOnlyTicketTypes (ticket) {
    return _.uniq([ serializers.code(ticket.ticketType), ticket.smartTicketType ].filter(Boolean));
}

class FareOnlySearchPreferences extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(FareOnlySearchPreferences, json, {
            routeCode: resolve.with(String),
            ticketTypes: resolve.with(Array),
            ticketCategory: resolve.with(String),
            duration: resolve.with(String),
            loadEarlier: resolve.with(Boolean),
        });
    }

    static fromString (dataString) {
        const dataArray = _.split(dataString, ',');
        const json = {
            routeCode: dataArray[0] ? dataArray[0] : null,
            ticketTypes: dataArray[1] ? dataArray[1] : null,
            ticketCategory: dataArray[2] ? dataArray[2] : null,
            duration: dataArray[3] ? dataArray[3] : null,
            loadEarlier: true,
        };
        return FareOnlySearchPreferences.fromJSON(json);
    }

    toJSON () {
        return serialize({
            routeCode: serializers.identity,
            ticketTypes: serializers.identity,
            ticketCategory: serializers.identity,
            duration: serializers.identity,
            loadEarlier: serializers.identity,
        }, this);
    }

    toString () {
        let toStringify = [
            serializers.identity(this.routeCode),
            serializers.identity(this.ticketTypes),
            serializers.identity(this.ticketCategory),
            serializers.identity(this.duration),
            serializers.identity(this.loadEarlier)
        ];
        return toStringify.join(',');
    }

    static fromFare(fare) {
        return new FareOnlySearchPreferences({
            routeCode: serializers.code(fare.route),
            ticketTypes: getFareOnlyTicketTypes(fare),
            duration: fare.isFlexi() ? 'FLEXI' : fare.getOutwardValidityPeriod().toISOString()
        });
    }

    static fromFavourite(favourite) {
        return new FareOnlySearchPreferences({
            routeCode: serializers.code(favourite.route),
            ticketTypes: getFareOnlyTicketTypes(favourite),
            duration: favourite.isFlexi() ? 'FLEXI' : favourite.duration
        });
    }
}

export default FareOnlySearchPreferences;
